import { buildProps } from '@vuesax-plus/utils'

import type { ExtractPropType } from '@vuesax-plus/utils'
import type Arrow from './arrow.vue'

export const arrowProps = buildProps({
  less: {
    type: Boolean,
  },
})

export type ArrowProps = ExtractPropType<typeof arrowProps>
export type ArrowInstance = InstanceType<typeof Arrow>
